import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import Scene from '../3D/Scene';
import LightCircle from '../3D/LightCircle';
import { isSmartphone } from '../_app/cuchillo/core/Basics';

class ScrollItem__BlockStep extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller)
        this.onShow = () => {
            this._lightCircle.show();
        };
        this.onHide = () => {
            this._lightCircle.hide();
        };

        const target = this.item.querySelector('.__target');
        if (target && !isSmartphone) {
            this._lightCircle = new LightCircle(target);
            Scene.addLightCircle(this._lightCircle);
        }
    }

    dispose() {
        if (this._lightCircle) { Scene.removeLightCircle(this._lightCircle); this._lightCircle = null; }
        super.dispose();
    }
}

Scroll._registerClass('BlockStep', ScrollItem__BlockStep);

export default ScrollItem__BlockStep;
